import { Box, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import "./sideMenuStyles.css";
import { useAppContext } from "../../context/AppContext";
import activeDashboardSvg from "../../../src/assets/sidebar/activeDashboard.svg";
import inActiveDashboardSvg from "../../../src/assets/sidebar/inactiveDashboard.svg";
import activeMithunSvg from "../../../src/assets/sidebar/activeMithun.svg";
import inActiveMithunSvg from "../../../src/assets/sidebar/inActiveMithun.svg";
import inActiveFarmerSvg from "../../../src/assets/sidebar/InactiveFarmer.svg";
import activeFarmerSvg from "../../../src/assets/sidebar/activeFarmer.svg";
import activeStateSvg from "../../../src/assets/sidebar/activeState.svg";
import inActiveStateSvg from "../../../src/assets/sidebar/inactiveState.svg";
import activeDistrictSvg from "../../../src/assets/sidebar/activedistrict.svg";
import inActiveDistrictSvg from "../../../src/assets/sidebar/inactivedistrict.svg";
import inActiveMandalSvg from "../../../src/assets/sidebar/inactveMandal.svg";
import activeMandalSvg from "../../../src/assets/sidebar/actveMandal.svg";
import activeVillageSvg from "../../../src/assets/sidebar/activeVillage.svg";
import inActiveVillageSvg from "../../../src/assets/sidebar/inactiveVillage.svg";
import inActiveTribesSvg from "../../../src/assets/sidebar/inactveTribes.svg";
import activeTribesSvg from "../../../src/assets/sidebar/actveTribes.svg";
import activeMithunSocietySvg from "../../../src/assets/sidebar/activeMithunSociety.svg";
import InActiveMithunSocietySvg from "../../../src/assets/sidebar/inactiveMithunSociety.svg";
import InActiveHealthSvg from "../../../src/assets/sidebar/inactiveHealth.svg";
import activeHealthSvg from "../../../src/assets/sidebar/activeHealth.svg";
import InActiveFeedSvg from "../../../src/assets/sidebar/inactiveFeed.svg";
import ActiveFeedSvg from "../../../src/assets/sidebar/activeFeed.svg";
import ActiveAnimalSvg from "../../../src/assets/sidebar/ActiveAnimalType.svg";
import InActiveAnimalSvg from "../../../src/assets/sidebar/inactiveAnimalType.svg";
import notificationSvg from "../../assets/notification-bell.svg";

function hasChildren(node) {
  return (
    typeof node === "object" &&
    typeof node.children !== "undefined" &&
    node.children.length > 0
  );
}

const MenuItem = (props) => {
  const { item } = props;
  const Component = hasChildren(item) ? MultiLevel : SingleLevel;
  return <Component item={item} />;
};

const SingleLevel = (props) => {
  const { pathname } = useLocation();
  const { item } = props;
  let itemProps = {};
  if (item.to) {
    itemProps = {
      component: NavLink,
      to: item.to,
    };
  }

  const isActive = pathname === item.activeTo;

  return (
    <Box
      {...itemProps}
      style={{ textDecoration: "none" }}
      display={"flex"}
      padding={"10px"}
      gap={"10px"}
      borderRadius={"6px"}
      alignItems={"center"}
    >
      <Box
        component="img"
        width={"22px"}
        height={"22px"}
        alt="Logo"
        src={
          pathname.includes(item.to)
            ? item.icon
            : isActive
              ? item.icon
              : item.inactiveIcon
        }
      />
      <Typography
        style={{ textDecoration: "none" }}
        fontFamily={"poppins"}
        fontSize={"15px"}
        color={
          item.to
            ? `${pathname.includes(item.to) || isActive ? "#59981A" : "black"}`
            : `${item.inactiveIcon ? "#f7f7f7" : null}`
        }
      >
        {" "}
        {item.title}
      </Typography>
    </Box>
  );
};

const MultiLevel = (props) => {
  const { pathname } = useLocation();
  const { item } = props;
  const { children } = item;

  const allPaths = item?.children?.map((item) => item?.to);

  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (allPaths.some((path) => pathname.startsWith(path))) {
      setExpanded(true);
    } else {
      setExpanded(false);
    }
  }, [pathname]);

  let itemProps = {};
  if (item.to) {
    itemProps = {
      component: NavLink,
      to: item.to,
    };
  }

  const handleClick = (e) => {
    setExpanded(!expanded);
  };

  return (
    <React.Fragment>
      <Box
        {...itemProps}
        button
        onClick={handleClick}
        style={{ textDecoration: "none" }}
        sx={{ cursor: "pointer" }}
        justifyContent={"space-between"}
        display={"flex"}
        gap={"10px"}
        padding={"10px"}
        borderRadius={"6px"}
        alignItems={"center"}
      >
        <Box display={"flex"} gap={"10px"}>
          <Typography fontSize={"15px"} fontFamily={"poppins"}>
            {item.title}
          </Typography>
        </Box>
        {expanded ? <ExpandLess /> : <ExpandMore />}
      </Box>
      <Box>
        {expanded && (
          <>
            {children.map((child, key) => (
              <MenuItem key={key} item={child} />
            ))}
          </>
        )}
      </Box>
    </React.Fragment>
  );
};

const SideMenuNew = (props) => {
  const navigate = useNavigate();

  const { user } = useAppContext();

  const [userMobile, setUserMobile] = useState(null);
  const [userCode, setUseCode] = useState(null);

  const [filteredMenuList, setFilteredMenuList] = useState([]);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("user") || "{}");
    setUseCode(userData);

    const mmmm = localStorage.getItem("loggedin_mobile")
    setUserMobile(mmmm);
  }, []);

  useEffect(() => {
    if (userCode?.role?.code === "b2bAdmin") {
      setFilteredMenuList(b2bMenuList);
    } else if (userCode?.role?.code === "branchManager") {
      setFilteredMenuList(branchManagerMenuList);
    }
  }, [userCode]);

  const b2bMenuList = [
    {
      title: "Dashboard",
      icon: require("../../assets/sidebar/dashboard.png"),
      inactiveIcon: require("../../assets/sidebar/dashboard.png"),
      to: "/dashboard",
      activeTo: "/dashboard",
    },
    {
      title: "Loan Officers",
      icon: require("../../assets/sidebar/loan-officer.png"),
      inactiveIcon: require("../../assets/sidebar/loan-officer.png"),
      to: "/loan-officers",
    },
    ...(userMobile && userMobile !== "9552025233"
      ? [
        {
          title: "Veterinaries",
          icon: require("../../assets/sidebar/veterinary.png"),
          inactiveIcon: require("../../assets/sidebar/veterinary.png"),
          to: "/veterinaries",
        },
      ]
      : []),
    {
      title: "Customers",
      icon: require("../../assets/sidebar/customer.png"),
      inactiveIcon: require("../../assets/sidebar/customer.png"),
      to: "/b2bfarmer"
    },
    {
      title: "Animals",
      icon: require("../../assets/sidebar/animal.png"),
      inactiveIcon: require("../../assets/sidebar/animal.png"),
      to: "/b2banimal"
    },
    {
      title: "Reports",
      icon: require("../../assets/sidebar/report.png"),
      inactiveIcon: require("../../assets/sidebar/report.png"),
      to: "/application-report",
    },
    {
      title: "Branch Managers",
      icon: require("../../assets/sidebar/loan-officer.png"),
      inactiveIcon: require("../../assets/sidebar/loan-officer.png"),
      to: "/branch-managers",
    },
    ...(userMobile && userMobile !== "9552025233"
      ? [
        {
          title: "Login Logs",
          icon: require("../../assets/sidebar/dashboard.png"),
          inactiveIcon: require("../../assets/sidebar/dashboard.png"),
          to: "/loginlogs",
        },
        {
          title: "Masters",
          icon: require("../../assets/shake.png"),
          inactiveIcon: require("../../assets/shake.png"),
          children: [
            {
              id: 8,
              title: "State",
              icon: require("../../assets/state.png"),
              inactiveIcon: require("../../assets/state.png"),
              to: "/master/states",
            },
            {
              id: 9,
              title: "District",
              icon: require("../../assets/district.png"),
              inactiveIcon: require("../../assets/district.png"),
              to: "/master/districts",
            },
            {
              id: 10,
              title: "Mandal",
              icon: require("../../assets/mandal.png"),
              inactiveIcon: require("../../assets/mandal.png"),
              to: "/master/mandals",
            },
            {
              id: 11,
              title: "Village",
              icon: require("../../assets/village.png"),
              inactiveIcon: require("../../assets/village.png"),
              to: "/master/villages",
            },
            {
              id: 12,
              title: "Circle Offices",
              icon: require("../../assets/village.png"),
              inactiveIcon: require("../../assets/village.png"),
              to: "/master/circle-office",
            },
            {
              id: 13,
              title: "Regional Offices",
              icon: require("../../assets/village.png"),
              inactiveIcon: require("../../assets/village.png"),
              to: "/master/regional-office",
            },
            {
              id: 14,
              title: "Branches",
              icon: require("../../assets/village.png"),
              inactiveIcon: require("../../assets/village.png"),
              to: "/master/branch",
            }
          ],
        },
        {
          title: "FAQs",
          icon: activeStateSvg,
          inactiveIcon: inActiveStateSvg,
          to: "/faq/view",
          activeTo: "/faq/view",
        },
      ]
      : []),
  ];

  const branchManagerMenuList = [
    {
      title: "Dashboard",
      icon: require("../../assets/sidebar/dashboard.png"),
      inactiveIcon: require("../../assets/sidebar/dashboard.png"),
      to: "/dashboard",
      activeTo: "/dashboard",
    },
    {
      title: "Customers",
      icon: require("../../assets/sidebar/customer.png"),
      inactiveIcon: require("../../assets/sidebar/customer.png"),
      to: "/b2bfarmer"
    },
    {
      title: "Animals",
      icon: require("../../assets/sidebar/animal.png"),
      inactiveIcon: require("../../assets/sidebar/animal.png"),
      to: "/b2banimal"
    },
    {
      title: "Reports",
      icon: require("../../assets/sidebar/report.png"),
      inactiveIcon: require("../../assets/sidebar/report.png"),
      to: "/application-report",
    },
  ];

  return (
    <>
      <Box>
        <Box
          bgcolor={"#fff"}
          height={"100vh"}
          borderRadius={"0px 12px 12px 0px"}
          boxShadow={"0px 24px 48px #00183414"}
          padding={"15px 15px 0px 15px"}
          position={"relative"}
        >
          <Box textAlign={"left"} mr={"10px"}>
            <img
              alt="anitraLogo"
              src={
                require("../../assets/logo.png")
              }
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </Box>
          <Box
            mt={1}
            className="sideMenu"
            sx={{
              scrollbarWidth: "thin",
              scrollbarColor: "transparent transparent",
              "&::-webkit-scrollbar": {
                width: "0.5em",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "transparent",
              },
            }}
          >
            {filteredMenuList.map((item, key) => (
              <MenuItem key={key} item={item} />
            ))}
          </Box>

          <Box position={"absolute"} bottom={"30px"} width={"100%"}>
            <Box
              display={"flex"}
              gap={"10px"}
              justifyContent={"flex-start"}
              alignItems={"center"}
            >
              <Box
                width={"70%"}
                display={"flex"}
                gap={"10px"}
                justifyContent={"center"}
                alignItems={"center"}
                padding={"10px"}
                onClick={() => {
                  navigate("/b2bfarmer/bin");
                }}
                sx={{ cursor: "pointer", textDecoration: 'underline' }}
              >
                <Typography
                  fontFamily={"poppins"}
                  fontSize={"15px"}
                >
                  Bin
                </Typography>
              </Box>
            </Box>

            <Box
              display={"flex"}
              gap={"10px"}
              justifyContent={"flex-start"}
              alignItems={"center"}
            >
              <Box
                width={"70%"}
                display={"flex"}
                gap={"10px"}
                justifyContent={"center"}
                alignItems={"center"}
                bgcolor={"#59981A"}
                padding={"10px"}
                borderRadius={"20px"}
                onClick={() => {
                  props.handleLogoutSuccess();
                  navigate("/login");
                }}
                sx={{ cursor: "pointer" }}
              >
                <Typography
                  fontFamily={"poppins"}
                  color={"#fff"}
                  fontSize={"15px"}
                >
                  Logout
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default SideMenuNew;
